<template>
  <div class="">
  <Modal
    v-model="editListModal"
    width="700"
    :title="editTitle"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListForm')"
  >
    <Form
      ref="editListForm"
      label-position="right"
      :label-width="120"
      :rules="ruleValidate"
      :model="editListForm"
    >
      <FormItem label="代理商"
        prop="agentName"
        label-for="agentName"
      >
        <Input
          placeholder="请输入代理商"
          element-id="agentName"
          v-model="editListForm.agentName"
        ></Input>
      </FormItem>
      <FormItem label="corpid"
        label-for="corpid"
      >
        <Input
          placeholder="请输入corpid"
          element-id="corpid"
          v-model="editListForm.corpid"
        ></Input>
      </FormItem>
      <FormItem label="所属渠道经理"
        prop="channelId"
        label-for="channelId"
      >
        <Select
          clearable
          filterable
          element-id="channelId"
          class="search-input"
          placeholder="请选择渠道经理"
          v-model="editListForm.channelId"
        >
          <Option
            v-for="orderType in sysroleList"
            :key="orderType.id"
            :value="orderType.id+''"
          >{{orderType.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="主管理员姓名"
        prop="userName"
        label-for="userName"
      >
        <Input
          placeholder="请输入姓名"
          element-id="userName"
          v-model="editListForm.userName"
        ></Input>
      </FormItem>
      <FormItem label="主管理员手机号"
        prop="phone"
        label-for="phone"
      >
        <Input
          placeholder="请输入手机号"
          element-id="phone"
          v-model="editListForm.phone"
        ></Input>
      </FormItem>
      <template v-if="edit === 1">
        <FormItem label="主管理员账号"
          prop="loginName"
          label-for="loginName"
        >
          <Input
            placeholder="请输入账号"
            element-id="loginName"
            v-model="editListForm.loginName"
          ></Input>
        </FormItem>
        <FormItem label="主管理员初始密码"
          prop="password"
          label-for="password"
        >
          <Input
            placeholder="请输初始密码"
            element-id="password"
            type="password"
            v-model="editListForm.password"
          ></Input>
        </FormItem>
      </template>
      <template v-if="edit === 2">
        <FormItem label="主管理员账号"
        >
          <span>{{editListForm.loginName}}</span>
        </FormItem>
        <FormItem label="主管理员初始密码"
        >
          <a href="javascript:;" @click="visible = true">重置密码</a>
        </FormItem>
     </template>
     <FormItem label="开户行"
       prop="bankName"
       label-for="bankName"
     >
       <Input
         placeholder="请输入开户行"
         element-id="bankName"
         v-model="editListForm.bankName"
       ></Input>
     </FormItem>
     <FormItem label="对公账号"
       prop="bankAccount"
       label-for="bankAccount"
     >
       <Input
         placeholder="请输入对公账号"
         element-id="bankAccount"
         v-model="editListForm.bankAccount"
       ></Input>
     </FormItem>
   </Form>
</Modal>
<!-- 重置密码 -->
    <Modal
    :mask-closable="false"
    :loading="loading"
    v-model="visible"
    @on-ok="resetPassword('resetLostForm')"
    title="重置密码">
       <Form
       label-position="right"
       ref="resetLostForm"
       :model="resetLostForm"
       :rules="ruleRest"
       :label-width="80">
        <FormItem
          label="重置密码"
          prop="password"
          label-for="password"
        >
          <Input
           type="password"
           v-model="resetLostForm.password"
           placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    agentId: {
      type: Number
    },
    editTitle: {
      type: String
    },
    editModal: {
      type: Boolean,
      required: true
    },
    editRow: {
      type: Object
    }
  },
  data () {
    const validateMobile = (rule, value, callback) => {
      if (!value.match(/[0-9-()（）]{7,15}/)) {
        callback(new Error('请输入正确的联系电话类型'))
      } else {
        callback()
      }
    }
    return {
      resetLostForm: {
        password: ''
      },
      sysroleList: [],
      isEdit: true,
      loading: true,
      editListForm: {
        id: '',
        agentName: '',
        corpid: '',
        channelId: '',
        userName: '',
        phone: '',
        loginName: '',
        password: '',
        bankName: '',
        bankAccount: ''
      },
      edit: 1,
      visible: false,
      editListModal: this.editModal,
      // 表单验证
      ruleRest: {
        password: [
          { required: true, message: '请输入最少6位密码', type: 'string', trigger: 'blur', min: 6 }
        ]
      },
      ruleValidate: {
        channelId: [
          { required: true, message: '必须选择一个渠道经理', trigger: 'change' }
        ],
        agentName: [
          { required: true, message: '请输入代理商', type: 'string', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入主管理员姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入主管理员手机号', trigger: 'change' },
          { validator: validateMobile, trigger: 'blur' },
          { max: 13, message: '请正确的联系电话', trigger: 'blur' }
        ],
        loginName: [
          { required: true, message: '请输入主管理员账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入最少6位密码', type: 'string', trigger: 'blur', min: 6 }
        ],
        bankName: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '请输入对公账号', type: 'string', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    editModal (val) {
      this.editListModal = val
      if (val) {
        this.reload()
      }
    },
    editListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  },
  methods: {
    // 保存编辑数据
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.editListForm
          }
          let url = '/agent'
          if (this.agentId > 0) {
            this.$http.put(url, data).then(res => {
              if (res.success) {
                let msg = '修改成功'
                this.$Message.success(msg)
                this.editListModal = false
                this.$emit('callback')
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            this.$http.post(url, data).then(res => {
              if (res.success) {
                let msg = '新增成功'
                this.$Message.success(msg)
                this.editListModal = false
                this.$emit('callback')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    },
    reload () {
      if (this.agentId !== -1) {
        this.edit = 2
        this.agentId = this.editRow.id
        this.editListForm.id = this.editRow.id
        this.editListForm.agentName = this.editRow.agentName
        this.editListForm.corpid = this.editRow.corpid
        let ChannelId = this.editRow.channelId
        this.editListForm.channelId = String(ChannelId)
        this.editListForm.loginName = this.editRow.loginName
        this.editListForm.bankName = this.editRow.bankName
        this.editListForm.bankAccount = this.editRow.bankAccount
        this.editListForm.userId = this.editRow.userId
        this.editListForm.userName = this.editRow.userName
        this.editListForm.phone = this.editRow.phone
      } else {
        this.edit = 1
        this.editListForm = {
          agentId: -1,
          id: '',
          agentName: '',
          corpid: '',
          channelId: '',
          userName: '',
          phone: '',
          loginName: '',
          password: '',
          bankName: '',
          bankAccount: ''
        }
      }
    },
    // 修改密码
    resetPassword (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            password: this.resetLostForm.password,
            id: this.editListForm.id
          }
          let url = '/user'
          this.$http.put(url, data).then(res => {
            if (res.success) {
              let msg = '重置密码成功'
              this.$Message.success(msg)
              this.$emit('callback')
              this.visible = false
              this.editListModal = false
              this.resetLostForm.password = ''
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    }
  },
  created () {
    this.$http.get('/user/listBySysrole?sysrole=2').then(res => {
      this.sysroleList = res.data
    })
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agentManages/AddAgent.vue